import * as actionTypes from './actionTypes';

export const toggle23LimitUpdate=()=>({
    type:actionTypes.TOGGLE_23LIMIT_UPDATE
})